<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <div class="d-flex align-items-center gap-2">
      <template v-if="valueLabelPosition === 'left'">
        <span>{{ valueLabel }}</span>
      </template>

      <Switches v-bind="context.attributes" v-model="model" type-bold="true" theme="custom" />

      <template v-if="valueLabelPosition === 'right'">
        <span>{{ valueLabel }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import Switches from 'vue-switches'

export default {
  components: {
    Switches,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
    // Sometimes you may need to use a function to return the value
    valueTrue: {
      type: [String, Number, Boolean, Function],
      default: () => true,
    },
    valueFalse: {
      type: [String, Number, Boolean, Function],
      default: () => false,
    },
    valueLabelTrue: {
      type: [String, Function],
      default: 'Active',
    },
    valueLabelFalse: {
      type: [String, Function],
      default: 'Inactive',
    },
    valueLabelPosition: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    model: {
      // 'get' is used to read the value from the model, and convert it to a boolean
      get() {
        if (typeof this.valueTrue === 'function') {
          return this.context.model === this.valueTrue()
        }

        return this.context.model === this.valueTrue
      },
      // 'set' is used to write the value to the model, and convert it
      // to the correct mapping based on valueTrue and valueFalse
      set(value) {
        if (value === true) {
          this.context.model =
            typeof this.valueTrue === 'function' ? this.valueTrue() : this.valueTrue

          return
        }

        this.context.model =
          typeof this.valueFalse === 'function' ? this.valueFalse() : this.valueFalse
      },
    },

    valueLabel() {
      if (this.model === true) {
        return typeof this.valueLabelTrue === 'function'
          ? this.valueLabelTrue()
          : this.valueLabelTrue
      }

      return typeof this.valueLabelFalse === 'function'
        ? this.valueLabelFalse()
        : this.valueLabelFalse
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.vue-switcher-theme--custom) {
  align-items: center;
  max-width: fit-content;

  div {
    background-color: $mep-primary;
    top: 0;

    &:after {
      // for the circle on the switch
      background-color: $white;
    }
  }

  &.vue-switcher--unchecked {
    div {
      background-color: transparent;
      border-style: solid;
      border-width: 1px;
      border-color: #99a1b1;

      &:after {
        background-color: #99a1b1;
      }
    }
  }
}
</style>
